module.exports = __webpack_public_path__ + "img/green_110.be9441c9.png";